import { map, pick } from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';
import { mapEnumValueForFilter, updateDeliveryStatusPropertyForFilter } from '../util/update-delivery-status-property-for-filter';

export class AppAdsAssetGroupSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);
    updatedSchema.properties = pick(updatedSchema.properties, [
      'Name',
      'DeliveryStatus',
      'Status',
      'PerformanceMetricsImpressions',
      'PerformanceMetricsClicks',
      'PerformanceMetricsCTR',
      'PerformanceMetricsConversionsCredit',
      'PerformanceMetricsSpend',
      'PerformanceMetricsAverageCPC',
      'PerformanceMetricsAdvertiserReportedRevenue',
      'PerformanceMetricsRevenueOnAdSpend',
      'PerformanceMetricsDownloads',
      'PerformanceMetricsFirstLaunches',
      'PerformanceMetricsPurchases',
      'PerformanceMetricsPostClickDownloadRate',
      'PerformanceMetricsCostPerDownload',
      'PerformanceMetricsPostClickFirstLaunchRate',
      'PerformanceMetricsCostPerFirstLaunch',
      'PerformanceMetricsPostInstallPurchaseRate',
      'PerformanceMetricsCostPerPurchase',
      'PerformanceMetricsPostInstallSubscriptionRate',
      'PerformanceMetricsCostPerSubscription',
    ], this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.SupportCPSForPmax ? [
      'PerformanceMetricsAverageCPS',
      'PerformanceMetricsSalesCount',
    ] : [], this.extraConfigForSchemaProcessor && this.extraConfigForSchemaProcessor.isMobileAppCampaign ? [
      'PerformanceMetricsVideoViews',
      'PerformanceMetricsVideoViewsAt25Percent',
      'PerformanceMetricsVideoViewsAt50Percent',
      'PerformanceMetricsVideoViewsAt75Percent',
      'PerformanceMetricsCompletedVideoViews',
      'PerformanceMetricsVideoCompletionRate',
    ] : []);

    const statusProperty = updatedSchema.properties.Status;
    const statusEnumSet = ['Active', 'Paused', 'Expired'];
    statusProperty.enum = map(statusEnumSet, value => mapEnumValueForFilter('AssetGroupStatus', value));

    const deliveryStatusEnumSet = [
      'Eligible',
      'AssetGroupExpired',
      'AssetGroupUserPaused',
      'CampaignUserPaused',
      'CampaignBudgetPaused',
      'CampaignSuspended',
      'CampaignInProgress',
      'ShoppingCampaignStoreNotFound',
      'ShoppingCampaignNoOffersPresent',
      'InvalidFinancialStatusOther',
      'EditorialApprovedLimited',
      'EditorialRejected',
      'EditorialUnderAppeal',
      'EditorialPending',
    ];

    if (this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.AppealUpheld) {
      deliveryStatusEnumSet.splice(deliveryStatusEnumSet.indexOf('EditorialApprovedLimited') + 1, 0, 'EditorialApprovedLimitedAppealRejected');
      deliveryStatusEnumSet.splice(deliveryStatusEnumSet.indexOf('EditorialRejected') + 1, 0, 'EditorialAppealRejected');
    }

    updateDeliveryStatusPropertyForFilter(updatedSchema, deliveryStatusEnumSet);

    return updatedSchema;
  }
}
